import React, { useState } from 'react';
import { postData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import { handleUserAccess } from '../../Utils/Auth';
import { useGlobal } from '../../Store';
import AuthLayout, { AuthCard, AuthHeading } from '../Layout/AuthLayout';
import { Button, FormField, TextInput } from '../UI';

export default function MFAChallenge({ mfaToken, onCancel }) {
  const [, globalActions] = useGlobal();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const submit = (e) => {
    if (e) e.preventDefault();
    const fd = new FormData();
    fd.append('mfa_token', mfaToken);
    fd.append('code', code);
    postData(Endpoints.LOGIN_MFA, fd)
      .then((res) => res.json())
      .then((res) => {
        if (res.token) {
          // handleUserAccess expects res.data.admin / res.data.token shape.
          // The MFA login endpoint returns a flat payload, so we wrap it.
          const wrapped = {
            data: {
              admin: res.admin || res.user_data || {},
              token: res.token,
              role: res.role || '',
              permissions: res.permissions || [],
              sessionId: res.sessionId || res.session_id || '',
            },
          };
          handleUserAccess(wrapped, globalActions, true);
        } else {
          setError(res.error || res.message || 'Verification failed');
        }
      })
      .catch(() => setError('Verification failed'));
  };

  return (
    <AuthLayout
      eyebrow="Two-factor"
      tagline="One more step. Enter the 6-digit code from your authenticator app to finish signing in."
    >
      <AuthCard>
        <AuthHeading>
          <h2>Verify it&apos;s you</h2>
          <p>Enter the authentication code from your app.</p>
        </AuthHeading>

        <form onSubmit={submit}>
          <FormField label="Authentication code" htmlFor="mfaCode" error={error}>
            <TextInput
              id="mfaCode"
              type="text"
              autoFocus
              inputMode="numeric"
              maxLength={6}
              $size="lg"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                if (error) setError('');
              }}
              placeholder="123456"
              style={{ letterSpacing: '0.5em', fontWeight: 700, textAlign: 'center' }}
            />
          </FormField>

          <Button type="submit" size="lg" fullWidth style={{ marginTop: 8 }}>
            Verify &amp; continue
          </Button>
          <Button
            type="button"
            variant="ghost"
            fullWidth
            onClick={onCancel}
            style={{ marginTop: 10 }}
          >
            Back to sign in
          </Button>
        </form>
      </AuthCard>
    </AuthLayout>
  );
}
